import React, { Component, ErrorInfo, ReactNode } from 'react';
import './error-boundary.css';
import { Box, Paper, Typography } from '@mui/material';

interface Props {
    children?: ReactNode;
    baseRelativeUrl?: string;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            //return <h1>Sorry.. there was an error</h1>;
            return (
                <Paper className="error-wrapper">
                    <Box id="error">Error</Box>
                    <Box className="error-num">
                        500
                        <Box className="error-num__clip">500</Box>
                    </Box>
                    <Typography paragraph={true} id="desc">Uh oh, there seems to be a problem.</Typography>
                    <Typography paragraph={true}>
                        Let me help you find{' '}
                        <a href={this.props.baseRelativeUrl ?? "/"} target="_blank" rel="noreferrer">
                            a way out
                        </a>
                    </Typography>
                </Paper>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
